const STORAGE_KEY = 'divipay:hideValues';

/** O que aparece no lugar do dinheiro quando o modo privacidade está ligado. */
export const HIDDEN_CURRENCY = 'R$ ••••••';

export const readStoredPreference = (): boolean => {
  try {
    return localStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    // Safari em navegação privada derruba o acesso ao storage.
    return false;
  }
};

// Flag de módulo, e não estado de contexto, porque `maskCurrency` é uma função pura chamada
// em ~260 lugares: transformá-la em hook obrigaria a mexer em todos eles. Quem dispara a
// re-renderização é o estado em `layouts/access` (ver PrivacyContext).
//
// ATENÇÃO: por ser um global mutável lido durante o render, o React não o enxerga como
// dependência. Nunca guarde o retorno de `maskCurrency` em `useMemo`/`useState` sem incluir
// `valuesHidden` nas dependências — o valor congela e o toggle deixa de funcionar, e nem o
// tsc nem os testes pegam isso.
let hidden = readStoredPreference();

/**
 * O app do cliente e as páginas públicas de pagamento (/charge, /link, /shared) moram na
 * mesma origem e dividem o localStorage. Sem este recorte, um lojista que liga a privacidade
 * em /access e abre o próprio link de cobrança vê "R$ ••••••" no valor a pagar, sem nenhum
 * botão naquela página para desligar.
 */
const isPrivacyScope = () => {
  try {
    return window.location.pathname.startsWith('/access');
  } catch {
    return false;
  }
};

/** A preferência crua, sem o recorte de rota — é o que o botão inverte. */
export const getPreference = () => hidden;

export const isValuesHidden = () => hidden && isPrivacyScope();

export const setValuesHidden = (value: boolean) => {
  hidden = value;
  try {
    localStorage.setItem(STORAGE_KEY, value ? '1' : '0');
  } catch {
    // Sem persistência a escolha vale só para esta sessão — melhor que quebrar o clique.
  }
};
